<div class="list-widget">
  <ul class="list-bulleted">
    <li *ngFor="let item of widget.data.items" [innerHtml]="item.text|safe"></li>
  </ul>
</div>
